import { render, staticRenderFns } from "./GluetunStatus.vue?vue&type=template&id=70d0eb18&scoped=true"
import script from "./GluetunStatus.vue?vue&type=script&lang=js"
export * from "./GluetunStatus.vue?vue&type=script&lang=js"
import style0 from "./GluetunStatus.vue?vue&type=style&index=0&id=70d0eb18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0eb18",
  null
  
)

export default component.exports